/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const interestDataRequestSchema = z.object({
	id: z.string(),
	name: z.string(),
	path: z.array(z.string()).nullable().optional(),
})

export type InterestDataRequestSchema = z.infer<typeof interestDataRequestSchema>
